(function () {
  var closeTimer = 0;
  var reduceMotion = false;

  try {
    reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  function quizDialog() {
    return document.getElementById("mc-curtain-quiz");
  }

  function openQuiz(event) {
    var dialog = quizDialog();
    if (!dialog) return;
    if (event) event.preventDefault();
    window.clearTimeout(closeTimer);
    dialog.classList.remove("is-closing");
    document.documentElement.classList.add("mc-cq-open");

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else if (!dialog.hasAttribute("open")) {
      dialog.setAttribute("open", "");
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        dialog.classList.add("is-open");
      });
    });
  }

  function finishClose(dialog) {
    dialog.classList.remove("is-open", "is-closing");
    if (typeof dialog.close === "function" && dialog.open) dialog.close();
    else dialog.removeAttribute("open");
    document.documentElement.classList.remove("mc-cq-open");
  }

  function closeQuiz() {
    var dialog = quizDialog();
    if (!dialog) return;
    if (!dialog.open && !dialog.hasAttribute("open")) return;

    if (reduceMotion) {
      finishClose(dialog);
      return;
    }

    dialog.classList.remove("is-open");
    dialog.classList.add("is-closing");
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      finishClose(dialog);
    }, 420);
  }

  function isQuizTrigger(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.hasAttribute("data-open-curtain-quiz")) return true;
    if (node.matches("a[href='#mc-curtain-quiz']")) return true;
    var href = node.getAttribute("href") || "";
    return /\/pages\/choose-my-curtain\/?(\?|#|$)/.test(href);
  }

  document.addEventListener("click", function (event) {
    var closeBtn = event.target.closest("[data-close-curtain-quiz]");
    if (closeBtn) {
      event.preventDefault();
      closeQuiz();
      return;
    }

    var trigger = event.target.closest("a, button");
    if (trigger && isQuizTrigger(trigger)) openQuiz(event);
  });

  document.addEventListener(
    "click",
    function (event) {
      var dialog = quizDialog();
      if (!dialog || !dialog.open) return;
      if (event.target === dialog) closeQuiz();
    },
    true
  );

  document.addEventListener("cancel", function (event) {
    if (event.target && event.target.id === "mc-curtain-quiz") {
      event.preventDefault();
      closeQuiz();
    }
  });

  if (
    window.location.hash === "#mc-curtain-quiz" ||
    /\/pages\/choose-my-curtain\/?$/.test(window.location.pathname)
  ) {
    openQuiz();
  }
})();
